import { cn } from '@/utils/cn';
import { DashedLine } from '@fleet/webshop-ui';

interface TicketCuticleLineProps {
  isVertical?: boolean;
  className?: string;
}

const TicketCuticleLine = ({
  isVertical = false,
  className,
}: TicketCuticleLineProps) => {
  return (
    <DashedLine
      isVertical={isVertical}
      dashLength={12}
      gapLength={4}
      color="#C2C8D6"
      className={cn('flex-1', className)}
    />
  );
};

export default TicketCuticleLine;
